import {AgGridReact} from "@ag-grid-community/react";
import {AgJob} from "../components/job/JobPanel";
import {PendingAssignment} from "../providers/AssignmentReducer";
import {useEffect} from "react";
import {IRowNode} from "@ag-grid-community/core";

export const useRedrawPendingRows = (
  gridRef: React.RefObject<AgGridReact<AgJob>>,
  pendingActions: PendingAssignment[],
  isReady: boolean
) => {
  useEffect(() => {
    if (isReady) {
      const redrawRowNodes: IRowNode<AgJob>[] = [];
      pendingActions.forEach((x) => {
        x.jobIds.forEach((y) => {
          const row = gridRef.current!.api.getRowNode(y?.toString());
          if (row) {
            row.setSelected(false);
            row.setRowHeight(0);
            redrawRowNodes.push(row);
          }
        });
      });
      gridRef.current!.api.onRowHeightChanged();
      gridRef.current!.api.redrawRows({rowNodes: redrawRowNodes});
    }
  }, [isReady, gridRef, pendingActions]);

  return null;
};
